// fullFaceBotoxData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const masseterBotox: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "",
            "description": "",
            "robots": "",
            "canonical": "",
            "og": {}
        },
        "breadcrumbs": ["Home", "Services", "Masseter Botox"],
        "hero": {
            "title": "Masseter Botox Dubai",
            "subtitle": "Refine Your Jawline, Relieve Tension",
            "description": "Are you seeking non-invasive help for face slimming, teeth grinding (bruxism) or jaw tension? One such treatment is Masseter Botox, which relaxes the masseter muscles for both pain relief and a slimmer jawline. Masseter Botox Dubai - Here at Elite Body Home, our skilled practitioners offer safe and effective Masseter Botox in Dubai."
        },
        "howItWorks": {
            "title": "What is Masseter Botox?",
            "description": "Masseter Botox injects botulinum toxin into the masseter muscles in the jaw. These muscles are important for chewing and can become hypertrophied (enlarged) due to overuse, giving you a square or bulky jawline. This is where Masseter Botox comes in — it works by relaxing these muscles and allows you to have a more sculpted, harmonious face. It's also widely used to address conditions such as bruxism, which can lead to jaw pain and tension."
        },
        "procedureSteps": {
            "heading": "Steps of the Masseter Botox Treatment",
            "para": "",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "After a thorough consultation to determine your requirements, facial structure, and medical history. The procedure is 100% safe and effective; the specialist will decide whether you are a candidate for Masseter Botox or not.",
                    "icon": "fa-regular fa-comment-dots"
                },
                {
                    "title": "Preparation",
                    "desc": "Cleaning of the treatment area (jawline) is done, and a numbing cream is applied in some cases to avoid discomfort.",
                    "icon": "fa-regular fa-hand-sparkles"
                },
                {
                    "title": "Marking the Injection Sites",
                    "desc": "The specialist will identify the exact spots the Botox will be injected into the masseter muscles and mark them.",
                    "icon": "fa-regular fa-map-marker-alt"
                },
                {
                    "title": "Botox Injections",
                    "desc": "Botox is injected into the masseter muscles on both sides of the jaw using a fine needle. The volume of injection is muscle or effect-specific.",
                    "icon": "fa-regular fa-syringe"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of Masseter Botox",
            "subheading": "",
            "para": "The benefits of Masseter Botox are numerous, including both aesthetic and therapeutic effects. This treatment is a solution whether you're wanting to improve facial symmetry or relieving pain from TMJ or bruxism.",
            "items": [
                {
                    "title": "Facial Slimming",
                    "desc": "Plump up sagging skin with a more structured jawline for a balanced facial dimension.",
                    "icon": "fa-regular fa-face-meh-blank"
                },
                {
                    "title": "Relief from Jaw Tension",
                    "desc": "Release tightening & discomfort from hyperactive masseter muscles.",
                    "icon": "fa-regular fa-teeth-open"
                },
                {
                    "title": "Non-Invasive Solution",
                    "desc": "Benefit from a fast, non-invasive procedure with little downtime.",
                    "icon": "fa-regular fa-hand-paper"
                },
                {
                    "title": "Bruxism Reduction",
                    "desc": "Less grinding and clenching of those teeth will be better for oral health.",
                    "icon": "fa-regular fa-tooth"
                },
                {
                    "title": "Natural-Looking Results",
                    "desc": "Muscle relaxation over time has a gentle, natural lipocontour effect.",
                    "icon": "fa-regular fa-face-smile"
                },
                {
                    "title": "Long-Lasting Impact",
                    "desc": "Experience 3 to 6 months of lasting results with regular treatments.",
                    "icon": "fa-regular fa-hourglass-half"
                }
            ]
        },
        "eligibility": {
            "heading": "Who is a good candidate for Masseter Botox?",
            "subheading": "Who Makes the Best Candidates for Masseter Botox?",
            "para": "This treatment is designed for those seeking aesthetic jawline contouring but can also help with symptoms of TMJ and bruxism. It's a safe procedure with very few risks when done by a qualified professional.",
            "items": [
                {
                    "title": "Aesthetic concerns",
                    "desc": "Those who have a square jawline and would like a more tapered appearance to the face.",
                    "icon": "fa-regular fa-face-frown-open"
                },
                {
                    "title": "TMJ disorder sufferers",
                    "desc": "Patients who are dealing with jaw pain, discomfort or tension from temporomandibular joint disorder.",
                    "icon": "fa-regular fa-head-side-cough"
                },
                {
                    "title": "Bruxism sufferers",
                    "desc": "People with a habit of grinding or clenching their teeth (particularly when sleeping).",
                    "icon": "fa-regular fa-teeth"
                },
                {
                    "title": "Overall good health",
                    "desc": "Candidates must be in good health and have no neuromuscular conditions that would inhibit the treatment.",
                    "icon": "fa-regular fa-heart-pulse"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation for Masseter Botox Injection",
            "subheading": "",
            "para": "Getting ready for Masseter Botox is quite easy. The goal is to keep you in peak form for the procedure and minimize bruising or swelling.",
            "items": [
                {
                    "title": "Avoid blood thinners",
                    "desc": "Do not take aspirin, ibuprofen or other blood-thinning medications for at least 48 hours before the procedure.",
                    "icon": "fa-regular fa-pills"
                },
                {
                    "title": "Limit alcohol consumption",
                    "desc": "Stay away from alcohol for at least 24-48 hours prior to treatment as this will minimize the chances of bruising.",
                    "icon": "fa-regular fa-wine-glass-empty"
                },
                {
                    "title": "Discuss medications",
                    "desc": "Let your provider know whether you take prescription medications, supplements or have health conditions.",
                    "icon": "fa-regular fa-clipboard-list"
                },
                {
                    "title": "Stay hydrated",
                    "desc": "Staying well-hydrated can help your body get ready for the treatment, and also recover afterward.",
                    "icon": "fa-regular fa-glass-water"
                }
            ]
        },
        "results": {
            "heading": "What to Expect After Masseter Botox: Results & Recovery",
            "subheading": "",
            "para": "Masseter Botox provides both aesthetic benefits and relief from discomfort. Recovery time is minimal, and results develop over the course of weeks.",
            "items": [
                {
                    "title": "Recovery Time",
                    "desc": "There's no downtime, and you can continue normal activities right away.",
                    "icon": "fa-regular fa-clock"
                },
                {
                    "title": "Initial Swelling",
                    "desc": "You may experience mild swelling or tenderness that usually resolves in a few days.",
                    "icon": "fa-regular fa-face-swelling"
                },
                {
                    "title": "Jawline Contouring",
                    "desc": "You will begin to see some results in 2-4 weeks with the maximum effect at 6 weeks.",
                    "icon": "fa-regular fa-image-portrait"
                },
                {
                    "title": "Symptom Relief",
                    "desc": "Patients with TMJ or bruxism also feel relief from tension and pain within a week or two after the procedure.",
                    "icon": "fa-regular fa-face-grin-wide"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Post Care for Masseter Botulinum Toxin Treatment",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "Minimal Downtime",
                    "desc": "You may resume normal activities now.",
                    "icon": "fa-regular fa-person-walking"
                },
                {
                    "title": "Avoid Pressure",
                    "desc": "Do not massage the area where you were treated for 24 hours.",
                    "icon": "fa-regular fa-hand"
                },
                {
                    "title": "Gradual Results",
                    "desc": "Over the next few weeks, the slimming effect becomes even more pronounced.",
                    "icon": "fa-regular fa-chart-line-up"
                },
                {
                    "title": "Long-Lasting",
                    "desc": "Results last for several months and most patients schedule regular touch-up treatments to maintain their desired results.",
                    "icon": "fa-regular fa-calendar-check"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "If you're considering Masseter Botox Treatment in Dubai, you may have questions about the procedure, results, and what to expect. Here are answers to common questions to help you make an informed decision.",
            "items": [
                {
                    "question": "Is Masseter Botox painful?",
                    "answer": "Most patients experience minimal discomfort during the procedure. We can use a topical anesthetic to ensure your comfort."
                },
                {
                    "question": "How soon will I see results?",
                    "answer": "Results from Masseter Botox typically begin to appear within 1–2 weeks after treatment, with full effects visible by 4 weeks."
                },
                {
                    "question": "How long do the effects last?",
                    "answer": "The effects typically last 3–6 months. Maintenance treatments are recommended to sustain results."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "Temporary side effects may include mild swelling, bruising, or tenderness at the injection sites, which usually resolve within a few days."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    },
    "shared": {
        "images": {
            "introductionImage": "",
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/New-Service-Bannefedfr-Image-1dd.jpg",
            "beforeAfter": [
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/masseter-botox-1.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/masseter-botox-2.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/masseter-botox-3.jpg"
            ]
        },
        "product": {
            "id": 6,
            "title": "Masseter Botox Dubai",
            "price": 499,
            "description": "Masseter Botox injects botulinum toxin into the masseter muscles in the jaw. These muscles are important for chewing and can become hypertrophied (enlarged) due to overuse, giving you a square or bulky jawline"
        }
    },

    "ar": {
        "url": "",
        "meta": {
            "title": "بوتوكس العضلة الماضغة في دبي | تنحيف الفك وتخفيف الألم",
            "description": "علاج بوتوكس العضلة الماضغة في دبي لتخفيف آلام الفك وتنحيف الوجه. حل غير جراحي لصرير الأسنان واضطرابات المفصل الفكي. احجز استشارتك الآن!",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/masseter-botox/",
            "og": {
                "locale": "ar_AR",
                "type": "article",
                "title": "بوتوكس العضلة الماضغة في دبي | تنحيف الفك وتخفيف الألم",
                "description": "علاج بوتوكس العضلة الماضغة في دبي لتخفيف آلام الفك وتنحيف الوجه. حل غير جراحي لصرير الأسنان واضطرابات المفصل الفكي. احجز استشارتك الآن!",
                "url": "https://elitebodyhome.com/services/masseter-botox/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2024-12-30T10:42:55+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-58.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-58.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "بوتوكس العضلة الماضغة",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "بوتوكس العضلة الماضغة في دبي | تنحيف الفك وتخفيف الألم",
                "description": "علاج بوتوكس العضلة الماضغة في دبي لتخفيف آلام الفك وتنحيف الوجه. حل غير جراحي لصرير الأسنان واضطرابات المفصل الفكي. احجز استشارتك الآن!",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-58.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "بوتوكس العضلة الماضغة"],
        "hero": {
            "title": "بوتوكس العضلة الماضغة دبي",
            "subtitle": "حدد خط فكك وتخلص من الألم!",
            "description": "هل تبحث عن حل غير جراحي لتنحيف الوجه أو علاج صرير الأسنان؟ يُعد بوتوكس العضلة الماضغة خيارًا فعّالًا، حيث يعمل على إرخاء عضلات الفك لتخفيف الألم ومنح وجهك مظهرًا أكثر نحافة. يقدم أطباؤنا المتخصصون في ايليت بودي هوم علاج بوتوكس العضلة الماضغة بأمان وفعالية في دبي."
        },
        "howItWorks": {
            "title": "ما هو بوتوكس العضلة الماضغة؟",
            "description": "يتم في علاج بوتوكسن العضلة الماضغة حقن مادة توكسين البوتولينوم في عضلات الفك الماضغة. تعتبر هذه العضلات أساسية لمضغ الطعام، لكنها قد تتضخم بسبب الإفراط في استخدامها، مما يمنح الفك مظهرًا ضخمًا. يعمل بوتوكس العضلة الماضغة على إرخاء هذه العضلات، مما يساعد في تنحيف الفك وتحقيق توازن مثالي لملامح الوجه. كما يُستخدم على نطاق واسع لعلاج حالات مثل صرير الأسنان، والذي قد يسبب آلامًا وتوترًا في الفك."
        },
        "procedureSteps": {
            "heading": "خطوات إجراء بوتوكس العضلة الماضغة",
            "para": "",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "تُجرى استشارة شاملة لتقييم احتياجاتك، وبنية وجهك، وتاريخك الطبي. يقرر المتخصص ما إذا كنت مرشحًا مناسبًا لبوتوكس العضلة الماضغة أم لا، بعد التأكد من أن الإجراء آمن لك وفعال بنسبة 100%.",
                    "icon": "fa-regular fa-comment-dots"
                },
                {
                    "title": "الاستعداد",
                    "desc": "تُنظف منطقة الفك جيدًا، وفي بعض الحالات، يتم استخدام مخدر موضعي لتقليل الشعور بالألم.",
                    "icon": "fa-regular fa-hand-sparkles"
                },
                {
                    "title": "تحديد مواقع الحقن",
                    "desc": "يقوم الطبيب المتخصص بتحديد النقاط الدقيقة التي سيتم فيها حقن البوتوكس داخل عضلات الماضغة، ثم يتم وضع علامات لتوجيه عملية الحقن.",
                    "icon": "fa-regular fa-map-marker-alt"
                },
                {
                    "title": "حقن البوتوكس",
                    "desc": "يتم حقن البوتوكس باستخدام إبرة دقيقة في عضلات الماضغة على جانبي الفك. تعتمد كمية الحقن على حجم العضلة والنتيجة المطلوبة.",
                    "icon": "fa-regular fa-syringe"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد بوتوكس للعضلة الماضغة",
            "subheading": "",
            "para": "يقدم بوتوكس العضلة الماضغة العديد من المزايا، سواء من الناحية التجميلية أو العلاجية. فهو الحل الأمثل لمن يرغب في تحسين تناسق الوجه أو التخفيف من آلام المفصل الفكي الصدغي أو صرير الأسنان. إليك أهم الفوائد:",
            "items": [
                {
                    "title": "تنحيف الوجه",
                    "desc": "يمنح الفك مظهراً أكثر تحديداً وتناسقاً، مما يساعد في تحقيق أبعاد وجه أكثر توازناً.",
                    "icon": "fa-regular fa-face-meh-blank"
                },
                {
                    "title": "تخفيف توتر الفك",
                    "desc": "يقلل من توتر العضلات والألم الناتج عن فرط نشاط العضلات الماضغة.",
                    "icon": "fa-regular fa-teeth-open"
                },
                {
                    "title": "علاج غير جراحي",
                    "desc": "يعد إجراء سريع وغير جراحي مع فترة تعافي قصيرة جداً.",
                    "icon": "fa-regular fa-hand-paper"
                },
                {
                    "title": "تقليل صرير الأسنان",
                    "desc": "يحد من صرير الأسنان والضغط عليها، مما يحسن صحة الفم والأسنان.",
                    "icon": "fa-regular fa-tooth"
                },
                {
                    "title": "نتائج طبيعية",
                    "desc": "يعمل على إرخاء العضلات تدريجياً، مما يمنح تأثيراً طبيعياً.",
                    "icon": "fa-regular fa-face-smile"
                },
                {
                    "title": "تأثير طويل الأمد",
                    "desc": "تدوم النتائج عادةً بين 3 إلى 6 أشهر مع إمكانية تكرار العلاج للحفاظ على النتيجة.",
                    "icon": "fa-regular fa-hourglass-half"
                }
            ]
        },
        "eligibility": {
            "heading": "من هو المرشح المناسب لعلاج بوتوكس العضلة الماضغة؟",
            "subheading": "",
            "para": "يعد بوتوكس العضلة الماضغة خيارًا مثاليًا للأشخاص الذين يسعون إلى تحديد الفك لأغراض تجميلية، كما أنه يساعد في تخفيف أعراض اضطرابات المفصل الفكي الصدغي (TMJ) وصرير الأسنان وهو إجراء آمن عند إجرائه من قبل متخصص.",
            "items": [
                {
                    "title": "الأشخاص الذين يرغبون في لمسات جمالية",
                    "desc": "إذا كنت تمتلك فكًا كبيرًا وترغب في مظهر أكثر تحديدًا وتناسقًا للوجه.",
                    "icon": "fa-regular fa-face-frown-open"
                },
                {
                    "title": "الأشخاص الذين يعانون من اضطرابات المفصل الفكي الصدغي (TMJ)",
                    "desc": "الأشخاص الذين يعانون من آلام الفك، أو التوتر العضلي نتيجة اضطرابات المفصل الفكي الصدغي.",
                    "icon": "fa-regular fa-head-side-cough"
                },
                {
                    "title": "الأشخاص الذين يعانون من صرير الأسنان (Bruxism)",
                    "desc": "الأفراد الذين يعانون من طحن الأسنان أو الضغط عليها، خاصة أثناء النوم، مما قد يؤدي إلى آلام الفك وتلف الأسنان.",
                    "icon": "fa-regular fa-teeth"
                },
                {
                    "title": "الأشخاص الذين يتمتعون بصحة عامة جيدة",
                    "desc": "يجب أن يكون المرشحون في حالة صحية جيدة وألا يعانوا من أي اضطرابات عصبية أو عضلية قد تؤثر على العلاج.",
                    "icon": "fa-regular fa-heart-pulse"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد لحقن بوتوكس العضلة الماضغة",
            "subheading": "",
            "para": "يُعد الاستعداد لجلسة بوتوكس العضلة الماضغة سهل للغاية، والهدف هو ضمان الحصول على أفضل النتائج مع تقليل احتمالية الكدمات أو التورم.",
            "items": [
                {
                    "title": "تجنب مُميعات الدم",
                    "desc": "يُفضل عدم تناول الأسبرين أو الإيبوبروفين أو أي أدوية مميعة للدم لمدة لا تقل عن 48 ساعة قبل الإجراء، لتقليل خطر الكدمات.",
                    "icon": "fa-regular fa-pills"
                },
                {
                    "title": "الامتناع عن شرب الكحول",
                    "desc": "يُوصى بالامتناع عن شرب الكحول لمدة 24-48 ساعة قبل العلاج، حيث يمكن أن يرفع من احتمالية حدوث تورم أو كدمات.",
                    "icon": "fa-regular fa-wine-glass-empty"
                },
                {
                    "title": "إبلاغ الطبيب عن الأدوية والمكملات الغذائية",
                    "desc": "أخبر طبيبك عن أي أدوية أو مكملات غذائية تتناولها أو حالات صحية تعاني منها قد تؤثر على العلاج.",
                    "icon": "fa-regular fa-clipboard-list"
                },
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "يساعد شرب كمية كافية من الماء الجسم على الاستعداد للعلاج ويسرّع من عملية التعافي بعد الإجراء.",
                    "icon": "fa-regular fa-glass-water"
                }
            ]
        },
        "results": {
            "heading": "ما يمكن توقعه من علاج بوتوكس العضلة الماضغة: النتائج والتعافي",
            "subheading": "",
            "para": "يقدم بوتوكس العضلة الماضغة فوائد جمالية وعلاجية، حيث يساعد في تحسين تناسق الفك وتخفيف التوتر والألم. تُعد فترة التعافي بعد العلاج قصيرة، وتتطور النتائج تدريجيًا على مدار أسابيع.",
            "items": [
                {
                    "title": "فترة التعافي",
                    "desc": "لا يتطلب العلاج فترة تعافي طويلة، ويمكنك استئناف أنشطتك اليومية فورًا.",
                    "icon": "fa-regular fa-clock"
                },
                {
                    "title": "آثار جانبية طفيفة",
                    "desc": "قد تشعر بتورم خفيف أو حساسية في المنطقة المعالجة، لكنها تختفي خلال بضعة أيام.",
                    "icon": "fa-regular fa-face-swelling"
                },
                {
                    "title": "نحت الفك",
                    "desc": "تبدأ النتائج بالظهور خلال 2-4 أسابيع، مع تحقيق النتائج النهائية خلال 6 أسابيع.",
                    "icon": "fa-regular fa-image-portrait"
                },
                {
                    "title": "تخفيف الأعراض",
                    "desc": "تحسن في أعراض اضطرابات المفصل الفكي الصدغي أو صرير الأسنان من توتر وألم العضلات خلال أسبوع إلى أسبوعين بعد العلاج.",
                    "icon": "fa-regular fa-face-grin-wide"
                }
            ]
        },
        "aftercareTips": {
            "heading": "نصائح العناية بعد العلاج",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "لا يتطلب فترة تعافي",
                    "desc": "يمكنك العودة إلى أنشطتك اليومية فورًا بعد العلاج.",
                    "icon": "fa-regular fa-person-walking"
                },
                {
                    "title": "تجنب الضغط على المنطقة",
                    "desc": "تجنب تدليك أو فرك المنطقة المُعالجة لمدة 24 ساعة لمنع انتشار البوتوكس إلى مناطق غير مستهدفة.",
                    "icon": "fa-regular fa-hand"
                },
                {
                    "title": "نتائج تدريجية",
                    "desc": "يتضح تأثير تنحيف الفك تدريجيًا حتى يصبح أكثر وضوحًا خلال الأسابيع القليلة القادمة.",
                    "icon": "fa-regular fa-chart-line-up"
                },
                {
                    "title": "نتائج طويلة الأمد",
                    "desc": "يستمر التأثير لعدة أشهر، ويلجأ معظم المرضى إلى جلسات متابعة منتظمة للحفاظ على النتائج المطلوبة.",
                    "icon": "fa-regular fa-calendar-check"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة المكررة",
            "subheading": "",
            "items": [
                {
                    "question": "هل بوتوكس العضلة الماضغة مؤلم؟",
                    "answer": "معظم المرضى لا يشعرون بألم يذكر أثناء الإجراء. يمكن استخدام مخدر موضعي لضمان راحتك."
                },
                {
                    "question": "متى سأرى النتائج؟",
                    "answer": "تبدأ نتائج بوتوكس العضلة الماضغة بالظهور خلال 1-2 أسبوع بعد العلاج، مع اكتمال النتائج خلال 4 أسابيع."
                },
                {
                    "question": "كم تدوم النتائج؟",
                    "answer": "تدوم النتائج عادةً من 3 إلى 6 أشهر. يُنصح بجلسات متابعة للحفاظ على النتائج."
                },
                {
                    "question": "هل هناك أي آثار جانبية؟",
                    "answer": "قد تشمل الآثار الجانبية المؤقتة تورمًا خفيفًا أو كدمات أو ألمًا في مواقع الحقن، والتي تختفي عادةً خلال بضعة أيام."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    }

};
